import { useIntl } from 'react-intl';

import { ApiWorkflowDialogMessages } from '@verantos-dev/shared-components';

import { useCohortBuilderModalContext } from '../../../../contexts/CohortBuilderModalContext';
import { useResetCohortBuilderState } from '../../../../hooks/common/useResetCohortBuilderState';

export const useCohortExitModal = () => {
  /** Active State */
  const intl = useIntl();
  const { closeDialog, exitAction } = useCohortBuilderModalContext();
  const { resetCohortBuilderState } = useResetCohortBuilderState();

  const onContinueEditing = () => {
    closeDialog();
  };

  const onExit = () => {
    resetCohortBuilderState();
    exitAction && exitAction();
  };

  const dialogMessages: ApiWorkflowDialogMessages = {
    entrySaveButtonText: intl.formatMessage({
      id: 'projects.cohortBuilderPage.cohortExitModal.processBtn',
    }),
    entryCancelButtonText: intl.formatMessage({
      id: 'projects.cohortBuilderPage.cohortExitModal.cancelBtn',
    }),
  };

  return {
    title: intl.formatMessage({ id: 'projects.cohortBuilderPage.cohortExitModal.title' }),
    confirmTitle: intl.formatMessage({
      id: 'projects.cohortBuilderPage.cohortExitModal.confirmTitle',
    }),
    content: (
      <>{intl.formatMessage({ id: 'projects.cohortBuilderPage.cohortExitModal.message1' })}</>
    ),
    dialogMessages,
    onContinueEditing,
    onExit,
  };
};
